/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppState } from 'src/app/services/app-state.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { API_SETTINGS } from '@touchplan/strings';
import { OrganizationAppEditorComponent } from 'src/app/modules/organizations/components/organization-app-editor/organization-app-editor.component';
import { OrganizationService } from '../../../../modules/organizations/services/organization.service';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
	selector: 'nav-bar-dashboard',
	templateUrl: './nav-bar-dashboard.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBarDashboardComponent implements OnInit {
	public appStrings = { API_SETTINGS };

	public isOrgAdmin$: Observable<boolean>;

	constructor(
		public appState: AppState,
		private router: Router,
		protected dialog: MatDialog,
		private authService: AuthService,
		private organizationService: OrganizationService
	) {}

	public ngOnInit() {
		this.isOrgAdmin$ = this.organizationService.isOrgAdmin$;
	}

	public goToProfile(): void {
		this.router.navigate(['account', 'profile']);
	}
	public goToMobile(): void {
		window.open('https://m.touchplan.io', '_self');
	}

	public logout(): void {
		this.authService.logout();
	}

	public openAPISettings() {
		OrganizationAppEditorComponent.openOrganizationApiSettings(this.dialog);
	}
}
